const Balance = ({className, points, balance} : {className?: string; points?:string; balance?: string;}) => {
    return (
        <div className="ac_bal">
            <span className={`common_btn btn-small ${className}`}>My Points  : {points}</span>
            <span className={`common_btn btn-small ${className}`}>Balance: {balance}</span>
        </div>
    )
}
export default Balance